import { Button } from '@mui/material';
import React from 'react';
import { useAppSelector } from 'src/redux/hooks';
import { Input, Routes } from 'src/lib/constants';
import { getLegacyTrackingValue } from 'src/utils/analytics/utils';
import { getExcludeInstitution } from 'src/redux/selectors';
import { GoalOption } from './hero-section/inner-cta-section/cta-component';

type SearchParams = Record<string, string | string[] | undefined>;
export const rebuildQueryString = (searchParams?: SearchParams): string => {
  const params = new URLSearchParams();
  Object.entries(searchParams ?? {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => {
        params.append(key, v);
      });
    } else if (value !== undefined) {
      params.append(key, value ?? '');
    }
  });

  const stringified = params.toString();

  return stringified ? `?${stringified}` : '';
};

type FlowCtaProps = {
  primaryGoal?: GoalOption;
  component?: React.ElementType;
  trkLocation?: string;
  children: React.ReactNode;
  [k: string]: any;
};

export const FlowCta: React.FC<FlowCtaProps> = ({
  primaryGoal,
  component: Component = Button,
  trkLocation,
  ...props
}) => {
  const excludedInstitutions = useAppSelector(getExcludeInstitution);

  const searchParams = {
    exclude_institution: excludedInstitutions,
    trk_location: trkLocation,
  } as SearchParams;

  if (primaryGoal !== '') {
    searchParams[Input.PrimaryGoal] = getLegacyTrackingValue(
      Input.PrimaryGoal,
      primaryGoal
    );
  }
  const href = `${Routes.Flow}${rebuildQueryString(searchParams)}`;
  return <Component href={href} {...props} />;
};
